"use client";

import { useEffect } from "react";
import { firstTouchSignupAttributionCookie } from "@/utils/signupAttribution.utils";
const rememberFirstTouch = () => {
  const cookie = firstTouchSignupAttributionCookie({
    url: new URL(window.location.href),
    cookieHeader: document.cookie,
    now: new Date()
  });
  if (cookie) document.cookie = cookie;
};
export function SignupAttributionCapture() {
  useEffect(rememberFirstTouch, []);
  return null;
}